export const getInputValues = map => {
	const obj = {}
	Object.entries(map).forEach(([key, item]) => {
		obj[key] = item.value
	})
	return obj
}
